export default __webpack_public_path__ + "static/media/blog2-3.9a79bc30.png";